export default {
  '***': {
  extraFilter: {
    type: 'sampleSizeFilter',
    ad_type: ['***'],
    disabledState: 'hidden',
    data: {
      sampleSize: 0
    }
  }
}
}


// WEBPACK FOOTER //
// ./src/app/configuration/FidelityV2/config/components/selection/Search/SearchFilter.js